import React from 'react';

import {
    createSelectorHook,
    createDispatchHook,
    ReactReduxContextValue,
    TypedUseSelectorHook,
} from 'react-redux';

import {HostApplicationStoreType} from '../../hostApplicationStoreType';

/**
 * The context used to provide the Host Redux store to the application.
 */
export const HostStoreContext = React.createContext<ReactReduxContextValue | null>(
    null as unknown as ReactReduxContextValue,
);

/**
 * Hook to access the Host Redux store via selector.
 */
export const useHostSelector: TypedUseSelectorHook<HostApplicationStoreType> =
    createSelectorHook(HostStoreContext);

/**
 * Hook to access the Host Redux store dispatch.
 */
export const useHostDispatch = createDispatchHook(HostStoreContext);
